import React, { useEffect, useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import { decodeID, encodeID, formatDisplayLongDate, getFromStorage, getPriceHelper, setDateFormat } from "../../utils/Helper";
import PageLoadingShell from "../layout/PageLoadingShell";
import ListPageSkeleton from "../layout/ListPageSkeleton";
import PageLoaderOverlay from "../layout/PageLoaderOverlay";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2'
import { StorageConstant } from '../../constants/Constants'
import { Modal } from "react-bootstrap";
import CheckOutModal from "../../Modal/CheckOutModal";
import AddressChangeMessage from "../../Modal/AddressChangeMessage";
import AddressChange from "../../Modal/AddressChange";
import OrderSuccessOverlay from "../layout/OrderSuccessOverlay";
import NewAddress from "../../Modal/NewAddress";
import ChatModal from "../../Modal/ChatModal";
import HistoryModal from "../../Modal/HistoryModal";
import { LanguageConstants } from "../../constants/LanguageConstants";
import { Routes } from "../../constants/RouteConstants";
import MessageHistoryModal from "../../Modal/MessageHistoryModal";
import "./MyQuotation.scss";

const QUOTATION_LIST_PAGE_SIZE = 20;

function MyQuotation() {
    const quotationList = useMakeRequest()
    const quotationReject = useMakeRequest()
    const messageHistoryReq = useMakeRequest()
    const [data, setData] = useState<any[]>([])
    const [listCount, setListCount] = useState(0)
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: QUOTATION_LIST_PAGE_SIZE,
    })
    const [status, setStatus] = useState('')
    const [activeStatus, setActiveStatus] = useState('')
    const [search, setSearch] = useState('')
    const [searchStatus, setSearchStatus] = useState(false)
    const [addressMessageShow, setAddressMessageShow] = useState(false)
    const [checkOutShow, setCheckOutShow] = useState(false)
    const [addressChangeShow, setAddressChangeShow] = useState(false)
    const [paymentshow, setPaymentshow] = useState(false)
    const [chatshow, setChatshow] = useState(false)
    const [chatData, setChatData] = useState({})
    const [historyshow, setHistoryshow] = useState(false)
    const [historyData, setHistoryData] = useState({})

    const [newAddress, setNewAddress] = useState(false)
    const [messgaeShow , setMessageShow] = useState(false)
    const [showDateFilter, setShowDateFilter] = useState(false)
    const [messageRows, setMessageRows] = useState<any[]>([])
    const [msgLoadingId, setMsgLoadingId] = useState<string | number | null>(null)
    const [statusLoadingValue, setStatusLoadingValue] = useState<string | null>(null)
    const [quoteIdLoading, setQuoteIdLoading] = useState(false)
    const [dateFilterApplyLoading, setDateFilterApplyLoading] = useState(false)
    const [dateFilterResetLoading, setDateFilterResetLoading] = useState(false)
    const [pendingCloseDateFilter, setPendingCloseDateFilter] = useState(false)



    const [checkOutdata, setCheckOutdata] = useState({})
    const [start_date, setStartDate] = useState<any>('')
    const [end_date, setEndDate] = useState<any>('')
    const formRef = useRef<HTMLFormElement>(null);
    const navigate = useNavigate()
    const [currency, setCurrency] = useState<any>({type:"PHP" , Index:'0'})
    const [activeMessageQuotationId, setActiveMessageQuotationId] = useState<string | number | null>(null)
    const [hasLoadedOnce, setHasLoadedOnce] = useState(false)
    const prevQuotationLoadingRef = useRef(false)
    const loadMoreSentinelRef = useRef<HTMLDivElement>(null)
    const scrollLoadGateRef = useRef({
        loading: false,
        hasMore: false,
        pageIndex: 0,
    })

    const getQuotationListRowKey = (row: any) => {
        const qid = row?.quotation_id
        if (qid != null && String(qid).trim() !== '') return `q-${qid}`
        if (row?.id != null) return `id-${row.id}`
        return null
    }

    const getListRowDate = (row: any) =>
        row?.updated_at ?? row?.updatedAt ?? row?.created_at ?? row?.createdAt

    const tabs = useMemo(() => ([
        { key: 'all', value: '', label: LanguageConstants?.ALL ?? 'All' },
        { key: 'quoting', value: '0', label: LanguageConstants?.NEW_PENDING ?? 'Quoting' },
        { key: 'quoted', value: '1', label: LanguageConstants?.NEW_Progress ?? 'Quoted' },
        { key: 'rejected', value: '3', label: LanguageConstants?.REJECT ?? 'Rejected' },
        { key: 'drafts', value: '4', label: LanguageConstants?.DRAFTS ?? 'Drafts' },
    ]), [])

    const formatListDate = (date: any) => formatDisplayLongDate(date, '-')

    const getItemsCount = (row: any) => {
        const val =
            row?.items_count ??
            row?.items ??
            row?.item_count ??
            row?.quotes_count ??
            row?.total_items ??
            (Array.isArray(row?.quotes_detail) ? row.quotes_detail.length : undefined) ??
            (Array.isArray(row?.quotes) ? row.quotes.length : undefined) ??
            (Array.isArray(row?.quotation_detail) ? row.quotation_detail.length : undefined)
        return (val === 0 || val) ? val : '-'
    }

    const getStatusCell = (row: any) => {
        if (row?.status == '0') return <span className="my-quotes__status--quoting">{LanguageConstants?.NEW_PENDING}</span>
        if (row?.status == '1') return <span className="my-quotes__status--quoted">{LanguageConstants?.NEW_Progress}</span>
        if (row?.status == '2') return <span className="approved-text">{LanguageConstants?.APPROVED}</span>
        if (row?.status == '3') return <span className="red-text">{LanguageConstants?.REJECT}</span>
        if (row?.status == '4') return <span className="my-quotes__status--draft">{LanguageConstants?.DRAFTS}</span>
        return <span>-</span>
    }

    /** Show Total Net when admin pricing exists (Quoted / Approved / Rejected). */
    const getListTotalNetDisplay = (row: any, rowIndex: number) => {
        const s = String(row?.status ?? '')
        if (s !== '1' && s !== '2' && s !== '3') return '---'
        const amount = Number(row?.total_amount)
        if (!Number.isFinite(amount) || amount <= 0) return '---'
        const symbol = currency?.Index == rowIndex && currency?.type == 'USD' ? '€' : '$'
        return `${symbol}${getPriceHelper(row?.total_amount)}`
    }


    useEffect(() => {
        setPagination((p) => (p.pageIndex === 0 ? p : { ...p, pageIndex: 0 }))
    }, [status, searchStatus, quotationReject?.status])

    useEffect(() => {
        const payload = {
            status: status,
            start_date: setDateFormat(start_date),
            end_date: setDateFormat(end_date),
            search: search?.trim(),
            page: pagination.pageIndex,
            pageSize: pagination.pageSize,
        }
        quotationList.makeRequest({ payload, url: ApiConstants?.QuotesList, toastStatus: false })
    }, [status, searchStatus, quotationReject?.status, pagination])

    useEffect(() => {
        const loading = Boolean(quotationList?.loading)
        const finished = prevQuotationLoadingRef.current === true && loading === false
        prevQuotationLoadingRef.current = loading

        if (!finished) {
            return
        }

        setStatusLoadingValue(null)
        setQuoteIdLoading(false)
        setDateFilterApplyLoading(false)
        setDateFilterResetLoading(false)

        if (quotationList?.status) {
            setActiveStatus(status)
            setHasLoadedOnce(true)
            if (pendingCloseDateFilter) {
                setShowDateFilter(false)
                setPendingCloseDateFilter(false)
            }
        } else if (pendingCloseDateFilter) {
            setPendingCloseDateFilter(false)
        }
    }, [quotationList?.loading, quotationList?.status, status, pendingCloseDateFilter])

    useEffect(() => {
        if (!quotationList?.status) {
            return
        }
        const newRows = quotationList?.data?.data?.rows ?? []
        const apiCount = Number(quotationList?.data?.data?.count) || 0
        setListCount(apiCount)
        setData((prev) => {
            if (pagination.pageIndex === 0) {
                return newRows
            }
            if (newRows.length === 0) {
                setListCount((c) => Math.min(c, prev.length))
                return prev
            }
            const seen = new Set(
                prev
                    .map((r: any) => getQuotationListRowKey(r))
                    .filter((k): k is string => k != null),
            )
            const appended = newRows.filter((r: any) => {
                const k = getQuotationListRowKey(r)
                if (k == null || seen.has(k)) return false
                seen.add(k)
                return true
            })
            return appended.length ? [...prev, ...appended] : prev
        })
    }, [quotationList?.status, quotationList?.data, pagination.pageIndex])

    scrollLoadGateRef.current = {
        loading: Boolean(quotationList?.loading),
        hasMore: listCount > 0 && data.length < listCount,
        pageIndex: pagination.pageIndex,
    }

    useEffect(() => {
        const el = loadMoreSentinelRef.current
        if (!el || !hasLoadedOnce || listCount <= 0) {
            return
        }
        const obs = new IntersectionObserver(
            (entries) => {
                const [entry] = entries
                if (!entry?.isIntersecting) return
                const g = scrollLoadGateRef.current
                if (g.loading || !g.hasMore) return
                setPagination((p) => ({
                    ...p,
                    pageIndex: p.pageIndex + 1,
                }))
            },
            { root: null, rootMargin: '120px', threshold: 0 },
        )
        obs.observe(el)
        return () => obs.disconnect()
    }, [hasLoadedOnce, listCount, data.length, quotationList.loading])

    const getTaxValue = (e: any) => {
        if (e?.tax_amount && e?.total_amount) {
            const total = Number(e?.total_shipping_price) + Number(e?.total_product_price) + Number(e?.other_charges)
            const taxValue = (total * e?.tax_amount) / 100;
            return `${taxValue.toFixed(2)}`;
        } else {
            return '$ 0.00';
        }
    };


    const handleStartDateInput = (e: any) => {
        setStartDate(e)
    }

    const handleEndDateInput = (e: any) => {
        setEndDate(e)
    }

    // search data 
    const handleSearch = (e: any) => {
        e.preventDefault()
        // decide whether this submit is date-filter or quote-id search
        const hasDate = Boolean(start_date || end_date)
        if (hasDate) {
            setDateFilterApplyLoading(true)
        } else {
            setQuoteIdLoading(true)
        }
        setPagination((p) => ({ ...p, pageIndex: 0 }))
        setSearchStatus(!searchStatus)
    }
    /** Date popover only: clear dates + search, keep panel open until list fetch completes */
    const handleDatePanelReset = () => {
        if (formRef.current) {
            formRef.current.reset();
        }
        setStartDate('')
        setEndDate('')
        setSearch('')
        setDateFilterResetLoading(true)
        setPendingCloseDateFilter(true)
        setPagination((p) => ({ ...p, pageIndex: 0 }))
        setSearchStatus(!searchStatus)
    }

    const hanldeNaviagate = (row: any) => {
        const qid = row?.quotation_id
        if (String(row?.status) === '4') {
            if (qid == null || qid === '') return
            navigate(
                `${Routes.RequestQuoteCreate}?draft=${encodeURIComponent(String(qid))}&step=1`
            )
            return
        }
        if (qid != null && qid !== '') {
            navigate(`/view-quotation/${qid}`)
        }
    }

    // Reject Quotation 
    const handelReject = (e: any) => {
        Swal.fire({
            title: LanguageConstants?.ARE_YOU_SURE,
            text: LanguageConstants?.REJECT_QUTO,
            icon: 'warning',
            // showCancelButton: true,
            confirmButtonColor: '#31CE36',
            cancelButtonColor: '#d33',
            showDenyButton: true,
            denyButtonText: 'No',
            confirmButtonText: 'Yes',
        }).then(async (result: any) => {
            if (result.isConfirmed) {
                const payload = {
                    quotation_id: e?.quotation_id
                }
                quotationReject.makeRequest({ payload, url: ApiConstants?.QuotesStatusUpdate, toastStatus: true })
            }
        });
    }

    // close checkout modal 
    const CloseCheckOutModal = () => {
        setCheckOutShow(false)
    }
    // Close Address Message Modal 
    const CloseAddressMessageModal = () => {
        setAddressMessageShow(false)
    }
    // Open checkout modal
    const handelCheckout = (e: any) => {
        setCheckOutShow(true)
        setCheckOutdata(e)
    }
    // clso new Address modal
    const handleClsoNewAddressModal = () => {
        setNewAddress(false)
    }

    // open chat popu modal
    const handleOpenChat = (e: any) => {
        setChatData(e)
        setChatshow(true)
    }

    // open history modal show
    const handleHistory = (e: any) => {
        setHistoryData(e)
        setHistoryshow(true)
    }

    // open message history modal show
    const handleMessageHistory = (e: any) => {
        const qid = e?.quotation_id
        setMsgLoadingId(qid ?? 'any')
        setActiveMessageQuotationId(qid ?? null)
        setHistoryData(e)
        const payload = { quotation_id: qid }
        messageHistoryReq.makeRequest({ payload, url: ApiConstants?.QuotesMessageHistory, toastStatus: false })
    }

    useEffect(() => {
        if (!messageHistoryReq?.status) return
        const rows = messageHistoryReq?.data?.data
        setMessageRows(Array.isArray(rows) ? rows : [])
        setMessageShow(true)
        setMsgLoadingId(null)
    }, [messageHistoryReq?.status])

    useEffect(() => {
        if (!messageHistoryReq?.loading && msgLoadingId != null && !messageHistoryReq?.status) {
            // request finished (likely error) – stop spinner
            setMsgLoadingId(null)
        }
    }, [messageHistoryReq?.loading])

    // naviagate to history-quotation page 
    const NaviagateHistory = (e: any) => {
        navigate(`/history/${encodeID(e?.quotation_id)}`)
    }

const ConvertPrice = (index: any, shipping_amount: any, totalamount: any, tax: any) => {
        setCurrency((prevCurrency:any) => ({...prevCurrency,type:currency?.type == "USD" ? "PHP" : "USD" , Index: index,}));
        if (currency.type == "PHP") {
           if(shipping_amount && totalamount){
            let newDataArr: any = [...data];
            const getPrice = localStorage.getItem('currencyValue')
            const priceValue = decodeID(getPrice)
            newDataArr = newDataArr[index] = {
                ...newDataArr[index],
                total_shipping_price: Number(shipping_amount * priceValue).toFixed(2),
                total_amount: Number(totalamount * priceValue).toFixed(2),
                other_charges: Number(tax * priceValue).toFixed(2),
                old_total_shipping_price: Number(shipping_amount).toFixed(2),
                old_total_amount: Number(totalamount).toFixed(2),
                old_other_charges: Number(tax).toFixed(2)
            }
            data.splice(index, 1)
            const newNumbers = [...data.slice(0, index), newDataArr, ...data.slice(index)];
            //@ts-ignore
            setData(newNumbers)
           }else{
           return
           } 
        } else {
            if(shipping_amount && totalamount){
                let newDataArr: any = [...data];
                newDataArr = newDataArr[index] = {
                    ...newDataArr[index],
                    total_shipping_price: Number(newDataArr[index].old_total_shipping_price ? newDataArr[index].old_total_shipping_price : newDataArr[index].total_shipping_price).toFixed(2),
                    total_amount: Number(newDataArr[index].old_total_amount ? newDataArr[index].old_total_amount : newDataArr[index].total_amount).toFixed(2),
                    other_charges: Number(newDataArr[index].old_other_charges ? newDataArr[index].old_other_charges : newDataArr[index].other_charges).toFixed(2),
                }
                data.splice(index, 1)
                const newNumbers = [...data.slice(0, index), newDataArr, ...data.slice(index)];
                //@ts-ignore
                setData(newNumbers) 
            }else{
                return
            }
        }
    }





    const showInitialPageLoader =
        !hasLoadedOnce &&
        (quotationList.loading || (!quotationList.status && quotationList.error == null));

    return (
        <>
            <PageLoaderOverlay show={quotationReject.loading} />
            <PageLoadingShell
                loading={showInitialPageLoader}
                skeleton={<ListPageSkeleton />}
                className="head-space"
            >
                <div className="inner-content">
                    <div className="my-quotes">
                            <div className="container">
                                <div className="page-box">
                                    <div className="page-box-inner">
                                        <form ref={formRef} onSubmit={handleSearch} className="my-quotes__toolbar">
                                            <div className="my-quotes__toolbarRow">
                                                <div className="my-quotes__searchGroup">
                                                    <div className="my-quotes__search">
                                                        {quoteIdLoading ? (
                                                            <span className="my-quotes__searchSpinner" aria-hidden="true" />
                                                        ) : (
                                                            <i className="icon-search" />
                                                        )}
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder={(LanguageConstants as Record<string, string>)?.QUOTE_SEARCH_QUOTE_ID ?? 'Search by Quote ID'}
                                                            aria-label={(LanguageConstants as Record<string, string>)?.QUOTE_SEARCH_QUOTE_ID ?? 'Search by Quote ID'}
                                                            value={search}
                                                            onChange={(e: any) => setSearch(e?.target?.value)}
                                                        />
                                                    </div>
                                                    <button
                                                        type="button"
                                                        className="my-quotes__calendarBtn"
                                                        aria-label={LanguageConstants?.Filter ?? 'Filter'}
                                                        onClick={() => setShowDateFilter((v) => !v)}
                                                    >
                                                        <i className="icon-calendar-2" />
                                                    </button>
                                                </div>

                                                {showDateFilter ? (
                                                    <div
                                                        className="my-quotes__datePopover"
                                                        role="region"
                                                        aria-label={LanguageConstants?.DATETYPE}
                                                        aria-busy={dateFilterApplyLoading || dateFilterResetLoading}
                                                    >
                                                        <div className="my-quotes__dateGrid">
                                                            <div className="my-quotes__dateField com-input-wrap">
                                                                <label className="form-label ms-2">{LanguageConstants?.FROM}</label>
                                                                <DatePicker
                                                                    className="form-control"
                                                                    placeholderText={LanguageConstants?.DATETYPE}
                                                                    timeFormat="MM DD YYYY"
                                                                    selected={start_date}
                                                                    maxDate={new Date()}
                                                                    onKeyDown={(e: any) => e.preventDefault()}
                                                                    onChange={handleStartDateInput}
                                                                />
                                                            </div>
                                                            <div className="my-quotes__dateField com-input-wrap">
                                                                <label className="form-label ms-2">{LanguageConstants?.TO}</label>
                                                                <DatePicker
                                                                    className="form-control"
                                                                    placeholderText={LanguageConstants?.DATETYPE}
                                                                    timeFormat="MM DD YYYY"
                                                                    disabled={start_date ? false : true}
                                                                    minDate={start_date}
                                                                    maxDate={new Date()}
                                                                    selected={end_date}
                                                                    onKeyDown={(e: any) => e.preventDefault()}
                                                                    onChange={handleEndDateInput}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="my-quotes__dateActions mb-1">
                                                            <button
                                                                type="submit"
                                                                className={`round-btn my-quotes__dateActionBtn my-quotes__dateActionBtn--primary ${dateFilterApplyLoading ? 'pointer-events-none' : ''}`}
                                                                onClick={(e: any) => handleSearch(e)}
                                                                disabled={quotationList.loading && (dateFilterApplyLoading || dateFilterResetLoading)}
                                                            >
                                                                {dateFilterApplyLoading
                                                                    ? <span className="my-quotes__dateBtnSpinner my-quotes__dateBtnSpinner--primary" aria-hidden="true" />
                                                                    : (LanguageConstants?.Filter)}
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className={`round-btn my-quotes__dateActionBtn my-quotes__dateActionBtn--primary ${dateFilterResetLoading ? 'pointer-events-none' : ''}`}
                                                                onClick={() => handleDatePanelReset()}
                                                                disabled={quotationList.loading && (dateFilterApplyLoading || dateFilterResetLoading)}
                                                            >
                                                                {dateFilterResetLoading
                                                                    ? <span className="my-quotes__dateBtnSpinner my-quotes__dateBtnSpinner--primary" aria-hidden="true" />
                                                                    : (LanguageConstants?.Reset)}
                                                            </button>
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </form>

                                        <div className="quotation-box my-quotes__box">
                                            <ul className="nav nav-pills my-quotes__tabs" role="tablist">
                                                {tabs.map((t) => (
                                                    <li
                                                        key={t.key}
                                                        className="nav-item"
                                                        role="presentation"
                                                        onClick={() => {
                                                            setStatusLoadingValue(t.value)
                                                            setPagination((p) => ({ ...p, pageIndex: 0 }))
                                                            setStatus(t.value)
                                                        }}
                                                    >
                                                        <button
                                                            className={`nav-link ${activeStatus === t.value ? "active" : ""}${
                                                                t.key === "quoting" ? " my-quotes__tab--quoting" : ""
                                                            }${t.key === "quoted" ? " my-quotes__tab--quoted" : ""}`}
                                                            type="button"
                                                            role="tab"
                                                            aria-selected={activeStatus === t.value}
                                                            disabled={quotationList.loading && statusLoadingValue === t.value}
                                                        >
                                                            {quotationList.loading && statusLoadingValue === t.value
                                                                ? <span className="my-quotes__tabSpinner" aria-hidden="true" />
                                                                : t.label}
                                                        </button>
                                                    </li>
                                                ))}
                                            </ul>

                                            <div className="manual-quote-table-wrap">
                                                <div className="table-responsive my-quotes__tableScroll">
                                                <table className="table my-quotes__table">
                                                    <thead>
                                                        <tr>
                                                            <th className="text-center">{LanguageConstants?.QUOTATIONID}</th>
                                                            <th className="text-center">
                                                                {getFromStorage({ key: StorageConstant?.Translate }) === 'spa'
                                                                    ? 'Estado de cotización'
                                                                    : 'Quote Status'}
                                                            </th>
                                                            <th className="text-center">{LanguageConstants?.DATE}</th>
                                                            <th className="text-center">{'Items'}</th>
                                                            <th className="text-center">{LanguageConstants?.TOTAL} {LanguageConstants?.NET}</th>
                                                            <th className="text-center">{LanguageConstants?.ORDER_COL_MSG ?? 'Msg'}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {data?.length > 0 ? data.map((res: any, i: any) => (
                                                            <tr key={getQuotationListRowKey(res) ?? i} className="my-quotes__row" onClick={() => hanldeNaviagate(res)}>
                                                                <td className="text-center">{String(res?.status) === '4' ? '---' : (res?.quotation_id ?? '---')}</td>
                                                                <td className="text-center">{getStatusCell(res)}</td>
                                                                <td className="text-center">{formatListDate(getListRowDate(res))}</td>
                                                                <td className="text-center">{getItemsCount(res) ?? '---'}</td>
                                                                <td className="text-center">
                                                                    {getListTotalNetDisplay(res, i)}
                                                                </td>
                                                                <td className="text-center">
                                                                    <button
                                                                        type="button"
                                                                        className="my-quotes__msgBtn"
                                                                        disabled={
                                                                            String(res?.status) === '4' ||
                                                                            (msgLoadingId === res?.quotation_id && messageHistoryReq.loading)
                                                                        }
                                                                        onClick={(e: any) => {
                                                                            e.stopPropagation()
                                                                            handleMessageHistory(res)
                                                                        }}
                                                                        aria-label={LanguageConstants?.MESSAGE ?? 'Message'}
                                                                    >
                                                                        {msgLoadingId === res?.quotation_id && messageHistoryReq.loading
                                                                            ? <span className="my-quotes__msgSpinner" aria-hidden="true" />
                                                                            : <span className="my-quotes__msgIcon" aria-hidden="true" />
                                                                        }
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )) : (
                                                            <tr>
                                                                <td colSpan={6}>
                                                                    <p className="text-center mt-3">{LanguageConstants?.NO_QUOTE_DATA}</p>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                                </div>
                                                {data.length > 0 && data.length < listCount ? (
                                                    <div
                                                        ref={loadMoreSentinelRef}
                                                        style={{ height: 1, width: '100%' }}
                                                        aria-hidden
                                                    />
                                                ) : null}
                                                {quotationList.loading && hasLoadedOnce && data.length > 0 ? (
                                                    <div className="text-center py-3" aria-busy="true">
                                                        <span className="my-quotes__tabSpinner" aria-hidden="true" />
                                                    </div>
                                                ) : null}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </PageLoadingShell>
            {/* Check Out Modal start */}
            <Modal show={checkOutShow}>
                <CheckOutModal handleClose={CloseCheckOutModal} data={checkOutdata} setAddressMessageShow={setAddressMessageShow} setPaymentshow={setPaymentshow} />
            </Modal>
            {/* Check Out Modal End */}


            {/* Address change message start */}
            <Modal show={addressMessageShow}>
                <AddressChangeMessage handleClose={CloseAddressMessageModal} setAddressChangeShow={setAddressChangeShow} />
            </Modal>
            {/* Address change message End */}


            {/* Address change  start */}
            <Modal show={addressChangeShow}  >
                <AddressChange setAddressChangeShow={setAddressChangeShow} data={checkOutdata} setNewAddress={setNewAddress} />
            </Modal>
            {/* Address change  End */}

            {/* Add new address  start */}
            <Modal show={newAddress}  >
                <NewAddress handleClose={handleClsoNewAddressModal} data={checkOutdata} setNewAddress={setNewAddress} />
            </Modal>
            {/* Add new address  End */}

            {/* Paymnet success   start */}
            <OrderSuccessOverlay show={paymentshow} isWireTransfer />
            {/* Paymnet success  End */}

            {/* Chat Modal  start */}
            <Modal show={chatshow} >
                <ChatModal data={chatData} setChatshow={setChatshow} />
            </Modal>
            {/* Chat Modal  end */}


            {/* History modal start */}
            <Modal show={historyshow} >
                <HistoryModal data={historyData} setHistoryshow={setHistoryshow} />
            </Modal>
            {/* History modal end */}


              {/* Message History modal start */}
            <Modal show={messgaeShow} >
                <MessageHistoryModal
                    quotationId={activeMessageQuotationId ?? (historyData as any)?.quotation_id}
                    rows={messageRows}
                    onClose={() => setMessageShow(false)}
                />
            </Modal>
            {/* Message History modal end */}




        </>
    )
}

export default MyQuotation